<!--
 * @Description:
 * @Author: wangjiawei
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-08-25 10:15:53
 * @LastEditors: linfangxing 2948276710@qq.com
 * @LastEditTime: 2023-02-09 11:35:48
 -->
<template>
  <div class="leader-page">
    <div class="header-title">
      <header>中国老年大学协会五届理事名单</header>
      <div>（以区划为序）</div>
    </div>
    <div class="container">
      <!-- <div v-for="item in this.leaderNameList" :key="item">
        <span v-for="(_item, index) in item" :key="index">{{_item}}</span>
      </div>-->
      <!-- <div>张晓林</div> -->
      <div>刁海峰</div>
      <div>刘&emsp;英</div>
      <div>董月星</div>
      <!-- <div>黄向阳</div> -->
      <!-- <div>祝东星</div> -->
      <div>张吉云</div>
      <div>杨海东</div>
      <div>杨文生</div>
      <div>吕清禄</div>
      <div>刘凤满</div>
      <div>刘&emsp;霞</div>
      <!-- <div>张永学</div> -->
      <div>李亚波</div>
      <div>宋铁鹏</div>
      <div>王&emsp;江</div>
      <div>张&emsp;兴</div>
      <div>黄&emsp;刚</div>
      <div>管&emsp;皎</div>
      <div>王玉珍</div>
      <div>赵壮志</div>
      <!-- <div>诸春华</div> -->
      <div>徐金祥</div>
      <div>吴德水</div>
      <!-- <div>陈先森</div> -->
      <div>杨根生</div>
      <div>杜英杰</div>
      <div>温洪军</div>
      <div>王青海</div>
      <!-- <div>孔玉芳</div> -->

      <!-- <div>尹海香</div> -->
      <div>陈良凤</div>
      <div>许光超</div>
      <!-- <div>林元和</div> -->
      <div>何天维</div>
      <div>彭初阳</div>
      <!--
        <div>陈&emsp;全</div>
      -->
      <!-- <div>渠&emsp;崎</div> -->
      <div>刘廷亮</div>
      <div>陈&emsp;宁</div>
      <div>伍&emsp;敏</div>
      <!-- <div>白向华</div> -->
      <div>毕&emsp;锟</div>
      <div>李&emsp;明</div>
      <div>曹正国</div>
      <!-- <div>龚宁川</div> -->
      <div>任继民</div>
      <!-- <div>刘&emsp;钢</div> -->
      <!-- <div>陶定宏</div> -->
      <div>王有昌</div>
      <div>林韵薇</div>
    </div>
    <div class="square">
      <ul class="leader-footer" v-if="showFooter">
        <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">顾秀莲</div>
          <div class="leader-job">中国老年大学协会名誉会长、</div>
          <div class="leader-job">第十届全国人大常委会副委员长</div>
        </li>
        <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">游德馨</div>
          <div class="leader-job">中国老年大学协会名誉会长、</div>
          <div class="leader-job">福建省第七、八届政协主席、</div>
          <div class="leader-job">福建省老年大学协会名誉会长、</div>
          <div class="leader-job">老年大学名誉校长</div>
        </li>

        <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">鲁昕</div>
          <div class="leader-job">中国老年大学协会顾问、</div>
          <div class="leader-job">首席专家、</div>
          <div class="leader-job">中国职业技术教育学会会长、</div>
          <div class="leader-job">国务院参事室特约研究员、</div>
          <div class="leader-job">十三届全国政协委员、</div>
          <div class="leader-job">原教育部副部长</div>
        </li>

        <!-- <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">张晓林</div>
          <div class="leader-job">中国老年大学协会会长、</div>
          <div class="leader-job">第十二届全国政协委员、</div>
          <div class="leader-job">求是杂志社原总编辑</div>
        </li> -->
        <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">刁海峰</div>
          <div class="leader-job">中国老年大学协会常务副会长、</div>
          <div class="leader-job">法定代表人、</div>
          <div class="leader-job">全国老龄办宣传部主任</div>
        </li>

        <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">刘英</div>
          <div class="leader-job">教育部职业教育与成人教育司二级巡视员</div>
          <div class="leader-job">教育部继续教育办公室主任</div>
        </li>
        <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">董月星</div>
          <div class="leader-job">中国老年大学协会副会长、</div>
          <div class="leader-job">中央军委政治工作部</div>
          <div class="leader-job">老干部局副局长</div>
        </li>
        <!-- <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">黄向阳</div>
          <div class="leader-job">中国老年大学协会副会长、</div>
          <div class="leader-job">教学工作委员会主任、</div>
          <div class="leader-job">中国科学院离退休干部局局长、</div>
          <div class="leader-job">中国科学院老年大学校长</div>
        </li> -->
        <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">宋铁鹏</div>
          <div class="leader-job">中国老年大学协会副会长、</div>
          <div class="leader-job">黑龙江省委组织部副部长、</div>
          <div class="leader-job">黑龙江省委老干部局局长、</div>
          <div class="leader-job">老干部大学常务副校长</div>
        </li>
        <!-- <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">陈先森</div>
          <div class="leader-job">中国老年大学协会副会长、</div>
          <div class="leader-job">安徽省老年大学协会会长、</div>
          <div class="leader-job">安徽省人大常委会原副主任</div>
        </li> -->
        <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">杨根生</div>
          <div class="leader-job">中国老年大学协会副会长、</div>
          <div class="leader-job">福建老年大学校长、</div>
          <div class="leader-job">福建省政协原副主席</div>
        </li>
        <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">杜英杰</div>
          <div class="leader-job">中国老年大学协会副会长、</div>
          <div class="leader-job">老年教育宣传出版</div>
          <div class="leader-job">工作委员会主任、</div>
          <div class="leader-job">山东省委组织部副部长兼老干部</div>
          <div class="leader-job">局局长老年大学校长</div>
        </li>
        <!-- <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">孔玉芳</div>
          <div class="leader-job">中国老年大学协会副会长、</div>
          <div class="leader-job">河南省老干部大学第一副校长、</div>
          <div class="leader-job">第十二届全国政协委员、</div>
          <div class="leader-job">河南省政协原副主席</div>
        </li> -->
        <!-- <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">周辉义</div>
          <div class="leader-job">中国老年大学协会副会长、</div>
          <div class="leader-job">湖北省委老干部局副局长、</div>
          <div class="leader-job">湖北省老年大学协会副会长</div>
        </li> -->
        <!-- <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">林元和</div>
          <div class="leader-job">中国老年大学协会副会长、</div>
          <div class="leader-job">广州市老年干部大学副校长、</div>
          <div class="leader-job">广东省广州市政协原主席</div>
        </li> -->
        <!--
        <li class="leader-wrapper">
          <div class="leader-header"></div>
          <div class="leader-name">陈全</div>
          <div class="leader-job">中国老年大学协会副会长、</div>
          <div class="leader-job">重庆市委组织部副部长</div>
          <div class="leader-job">兼老干部局局长、</div>
          <div class="leader-job">政协重庆市第五届委员会文化文史和学习委员会副主任</div>
        </li>
        -->
      </ul>
    </div>
  </div>
</template>

<script>
import Api from "../../api/aboutApi";
import store from "../../store/index";
export default {
  data() {
    return {
      leaderNameList: [],
      showFooter: false,
    };
  },
  created() {
    this.showFooter = false;
    Api.getLeaderNameList()
      .then((res) => {
        store.commit(
          "About/leaderNameList",
          res.data.map((item) => item.name)
        );
        this.leaderNameList = res.data.map((item) => item.name);
        this.showFooter = true;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import url("minireset.css");

@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}

.leader-page {
  padding: 60px 90px 60px 90px;
}

.header-title {
  text-align: center;

  & > header {
    @include font-style("PingFangSC-Medium", 36px, rgba(58, 58, 58, 1), 500);
    line-height: 50px;
    letter-spacing: 1px;
  }

  & > div {
    margin-top: 10px;
    @include font-style("PingFangSC-Regular", 20px, rgba(58, 58, 58, 1), 400);
    line-height: 28px;
  }
}

.container {
  margin-top: 20px;

  & > div {
    display: inline-flex;
    justify-content: space-between;
    min-width: 56px;
    margin-right: 13px;
    margin-bottom: 14px;
    @include font-style("PingFangSC-Regular", 18px, rgba(58, 58, 58, 1), 400);
    line-height: 25px;
  }

  // & > div:nth-child(11n) {
  //   margin-right: 0;
  // }
}

.leader-footer {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 26px;

  // display: grid;
  // grid-template-columns: 1fr 1fr 1fr;
  // grid-template-rows: 310px 310px 310px;
  // grid-gap: 20px 20px;
  & > .leader-wrapper {
    width: 204px;
    margin-right: 17px;
    margin-bottom: 20px;
    background: rgba(248, 248, 248, 1);
    border-radius: 4px;
    text-align: center;
    padding: 0 18px 10px 18px;
    height: 325px;

    .leader-header {
      width: 110px;
      height: 110px;
      margin: 30px auto 20px auto;
      border-radius: 50%;
      background-size: 100% 100%;
    }

    .leader-name {
      @include font-style("PingFangSC-Medium", 18px, rgba(58, 58, 58, 1), 500);
      line-height: 25px;
    }

    .leader-job {
      margin-top: 5px;
      @include font-style(
        "PingFangSC-Regular",
        14px,
        rgba(122, 122, 122, 1),
        400
      );
      line-height: 18px;
    }
  }

  & > .leader-wrapper:nth-child(3n) {
    margin-right: 0;
  }

  & > .leader-wrapper:last-child {
    margin-bottom: 0;
  }

  & > .leader-wrapper:nth-of-type(1) {
    .leader-header {
      background-image: url("../../assets/about/guxiulian.png");
    }
  }

  & > .leader-wrapper:nth-of-type(2) {
    .leader-header {
      background-image: url("../../assets/about/youdexin.png");
    }
  }

  & > .leader-wrapper:nth-of-type(3) {
    .leader-header {
      background-image: url("../../assets/about/luxin.png");
    }
  }

  // & > .leader-wrapper:nth-of-type(4) {
  //   .leader-header {
  //     background-image: url("../../assets/about/zhangxiaolin.png");
  //   }
  // }

  & > .leader-wrapper:nth-of-type(4) {
    .leader-header {
      background-image: url("../../assets/about/diaohaifeng.png");
    }
  }

  & > .leader-wrapper:nth-of-type(5) {
    .leader-header {
      background-image: url("../../assets/about/liuying.png");
    }
  }

  & > .leader-wrapper:nth-of-type(6) {
    .leader-header {
      background-image: url("../../assets/about/dongyuexing.png");
    }
  }

  // & > .leader-wrapper:nth-of-type(8) {
  //   .leader-header {
  //     background-image: url("../../assets/about/huangxiangyang.png");
  //   }
  // }

  & > .leader-wrapper:nth-of-type(7) {
    .leader-header {
      background-image: url("../../assets/about/songtiepeng.png");
    }
  }

  // & > .leader-wrapper:nth-of-type(8) {
  //   .leader-header {
  //     background-image: url("../../assets/about/chenxiansen.png");
  //   }
  // }

  & > .leader-wrapper:nth-of-type(8) {
    .leader-header {
      background-image: url("../../assets/about/yanggensheng.png");
    }
  }

  & > .leader-wrapper:nth-of-type(9) {
    .leader-header {
      background-image: url("../../assets/about/duyingjie.png");
    }
  }

  // & > .leader-wrapper:nth-of-type(12) {
  //   .leader-header {
  //     background-image: url("../../assets/about/kongyufang.png");
  //   }
  // }

  // & > .leader-wrapper:nth-of-type(14) {
  //   .leader-header {
  //     background-image: url("../../assets/about/zhouhuiyi.png");
  //   }
  // }

  // & > .leader-wrapper:nth-of-type(13) {
  //   .leader-header {
  //     background-image: url("../../assets/about/linyuanhe.png");
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/about/Leader.vue